import clsx from "clsx";
import React, { useContext, useState } from "react";
import { LanguageContext, text } from "../../container/language";
import { usePageContext } from "../../utils/PageContext";
import Paragraph from "../Article/Paragraph";
import Paragraphs from "../Article/Paragraphs";
import "./style.scss";
import Link from "../../utils/Link";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";

const Item = ({ data, isActive, onClick }) => {
  const { title, sections = [] } = data;
  const { lang } = usePageContext();

  return (
    <>
      <a
        href="javascript:;"
        className={`tabs__link js-tabs__link ${isActive ? "is-active" : ""}`}
        data-tab="tab-43-1"
        onClick={onClick}
      >
        {text(title, lang)}
      </a>
      <div
        className={`tabs__content js-tabs__content ${
          isActive ? "is-active" : ""
        }`}
        id="tab-43-1"
        data-tab="tab-43-1"
      >
        <div className="tabcontent">
          {sections.map(({ head, body = [] }) => {
            return (
              <section className="tabsection">
                <div className="wrapper">
                  <div className="text">
                    <ul className="credit-list">
                      <li className="credit-list__item">
                        <div className="credit-list__header">
                          <Link
                            className="credit-list__title"
                            to={buildURLForMenuItem(head)}
                          >
                            {text(head.label, lang)}
                          </Link>
                        </div>
                        <div className="credit-list__body">
                          <ul>
                            {body.map((item) => (
                              <li>
                                <Link to={buildURLForMenuItem(item)}>
                                  {text(item.label, lang)}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </>
  );
};

export const BusinessNeeds = ({ data }) => {
  const [index, setIndex] = useState(0);

  return (
    <div style={{ marginTop: "20px", marginBottom: "70px" }}>
      <div className="tabs tabs--icons js-tabs">
        {data.items.map((item, i) => {
          return (
            <Item
              data={item}
              isActive={i === index}
              onClick={() => setIndex(i)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BusinessNeeds;
